import { render, staticRenderFns } from "./WorkflowNameShort.vue?vue&type=template&id=f778175e&"
import script from "./WorkflowNameShort.vue?vue&type=script&lang=ts&"
export * from "./WorkflowNameShort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports